<template>
  <div>
    <slot />
    <label v-show="!isValid || showErrorLabel" class="e-error">{{ errorLabel }}</label>
  </div>
</template>

<script>
export default {
  name: "SccInputValidator",
  props: {
    errorLabelMessage: String,
    showErrorLabel: Boolean,
    value: {
      type: [String, Number],
      default: null,
    },
    dateValue: {
      default: null,
    },
    number: {
      type: Number,
      default: null,
    },
    password: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    usedPasswords: {
      type: Array,
      default() {
        return [];
      },
    },
    currentPassword: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      errorMessage: null,
      isValid: true,
    };
  },
  computed: {
    errorLabel() {
      return this.errorMessage ? this.errorMessage : this.errorLabelMessage;
    },
  },
  watch: {
    value(value) {
      this.checkIfValid(value);
    },
    dateValue(dateValue) {
      // eslint-disable-next-line no-param-reassign
      dateValue = dateValue ? new Date(dateValue).toLocaleDateString() : "";
      this.checkIfValid(dateValue);
    },
    password() {
      // if password is not required then cleanup message
      let valid = true;
      if (
        (this.rules === null || this.rules.length === 0)
        && (this.password === null || this.password === "")
      ) {
        this.errorMessage = "";
        return valid;
      }
      // --- new password cannot same as current password.
      if (this.currentPassword !== null && this.currentPassword !== "") {
        if (this.currentPassword === this.password) {
          valid = false;
          this.errorMessage = "cannot reuse current password.";
        }
      }
      // --- check passwod reused or not
      if (
        this.usedPasswords !== null
        && this.usedPasswords.length > 0
        && this.usedPasswords.some((data) => data.some((p) => p.password === this.password))
      ) {
        valid = false;
        this.errorMessage = "cannot reuse previous password.";
      }
      if (valid) {
        if (this.rules === null) {
          this.rules = [
            { regEx: "[a-z]", message: "One lowercase letter required." },
            { regEx: "[A-Z]", message: "One uppercase letter required." },
            { regEx: "[0-9]", message: "One number required." },
            { regEx: ".{12,}", message: "12 characters minimum." },
          ];
        } else {
          this.rules.push(
            { regEx: "[a-z]", message: "One lowercase letter required." },
            { regEx: "[A-Z]", message: "One uppercase letter required." },
            { regEx: "[0-9]", message: "One number required." },
            // { regEx: '[#?!@$%^&*-]', message: 'At least one special character.' },
            { regEx: ".{12,}", message: "12 characters minimum." },
          );
        }
        this.rules.every((r) => {
          const exp = new RegExp(r.regEx);
          valid = exp.test(this.password);
          this.errorMessage = !valid ? r.message : "";
          return valid;
        });
      }
      this.isValid = valid;
      this.$emit("validate", valid);
      this.rules = null;
      this.usedPasswords = null;
      return valid;
    },
    number() {
      const valid = this.number !== null;
      this.errorMessage = !valid ? "This field is required" : "";
      this.isValid = valid;
      this.$emit("validate", valid);
    },
    // booleanValue() {
    //   let valid = true;
    //   this.rules.every((r) => {
    //     const exp = new RegExp(r.regEx, 'i');
    //     valid = exp.test(this.booleanValue);
    //     this.errorMessage = !valid ? r.message : '';
    //     return valid;
    //   });
    //   this.isValid = valid;
    //   this.$emit('validate', valid);
    // },
  },
  methods: {
    checkIfValid(value) {
      const allowNull = !this.rules
        .map((x) => x.message)
        .find((x) => x.toLowerCase().includes("required"));
      let valid = true;
      this.rules.every((r) => {
        const exp = new RegExp(r.regEx);
        if (!value && !allowNull) {
          valid = false;
        } else {
          valid = !value && allowNull ? true : exp.test(value);
        }
        this.errorMessage = !valid ? r.message : "";
        return valid;
      });
      this.isValid = valid;
      this.$emit("validate", valid);
    },
  },
};
</script>

<style scoped></style>
